import Swal from 'sweetalert2';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';


class MessageService {

    static confirmMsg({ formatMessage, titleIntl, textIntl, cb, addObj = null, cancelCb = null }) {
        let text = addObj ? formatMessage({ id: textIntl }, addObj) : formatMessage({ id: textIntl })
        Swal.fire({
            title: formatMessage({ id: titleIntl }),
            text: text,
            showCancelButton: true,
            cancelButtonText: formatMessage({ id: "common.cancel" }),
            confirmButtonText: formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false
        }).then((res) => {
            if (res.value) cb();
            else if (cancelCb) cancelCb();
        });
    }

    static infoMsg({ formatMessage, titleIntl, textIntl }) {
        Swal.fire({
            title: formatMessage({ id: titleIntl }),
            text: formatMessage({ id: textIntl }),
            confirmButtonText: formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            buttonsStyling: false,
            type: 'message'
        });
    }

    static confirmDDMsg({ formatMessage, titleIntl, textIntl, options, cb }) {
        Swal.fire({
            title: formatMessage({ id: titleIntl }),
            text: formatMessage({ id: textIntl }),
            input: 'select',
            inputOptions: options,
            showCancelButton: true,
            cancelButtonText: formatMessage({ id: "common.cancel" }),
            confirmButtonText: formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    const errors = [];
                    if (!(value > 0)) { errors.push("Please select data!") }
                    if (errors.length) resolve(errors.join(' '));
                    else resolve();
                });
            },
        }).then((res) => {
            if (res.value && res.value > 0) cb(res);
        });
    }


    static confirmInputDDMsg({ formatMessage, titleIntl, textInputIntl, textDDIntl, options, cb }) {
        Swal.fire({
            title: formatMessage({ id: titleIntl }),
            showCancelButton: true,
            cancelButtonText: formatMessage({ id: "common.cancel" }),
            confirmButtonText: formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            input: 'select',
            inputOptions: options,
            html:
                '<div>' + formatMessage({ id: textInputIntl }) + '</div>' +
                '<input id="swal-input1" class="swal2-input" autofocus>' +
                '<div>' + formatMessage({ id: textDDIntl }) + '</div>',
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    let name = document.getElementById('swal-input1').value;
                    if (!name) resolve(formatMessage({ id: "popup.validation.insert.name" }));
                    else resolve();
                });
            },
            preConfirm: (value) => {
                return new Promise((resolve) => {
                    if (true) resolve([document.getElementById('swal-input1').value, value]);
                });
            }
        }).then((result) => {
            if (result.value && result.value[0] && result.value[1]) cb(result)
        });
    }

    static confirmInputMsg({ formatMessage, titleIntl, textInputIntl, textDDIntl, cb }) {
        Swal.fire({
            title: formatMessage({ id: titleIntl }),
            showCancelButton: true,
            cancelButtonText: formatMessage({ id: "common.cancel" }),
            confirmButtonText: formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            html:
                '<div>' + formatMessage({ id: textInputIntl }) + '</div>' +
                '<input id="swal-input1" class="swal2-input" autofocus>' +
                '<div>' + formatMessage({ id: textDDIntl }) + '</div>',
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    let name = document.getElementById('swal-input1').value;
                    if (!name) resolve(formatMessage({ id: "popup.validation.insert.name" }));
                    else resolve();
                });
            },
            preConfirm: (value) => {
                return new Promise((resolve) => {
                    if (true) resolve([document.getElementById('swal-input1').value, value]);
                });
            }
        }).then((result) => {
            console.log("LAMTEST confirmInput result", result);
            if (result.value && result.value[0]) cb(result)
        });
    }
}

export default MessageService;